<ng-container *cdkPortal>
  @if (content !== null) {
    <div class="skymiles-landing-page-membership-card">
      <div class="skymiles-landing-page-membership-card__view">
        <img [alt]="content.image.alt" [src]="content.image.src" />
      </div>
      <div class="skymiles-landing-page-membership-card__user">
        {{ content.user.name }}
        <br />
        {{ content.user.skymilesNumber }}
        <br />
        {{ content.user.validity.title }} {{ content.user.validity.subtitle }}
      </div>
      <div class="skymiles-landing-page-membership-card__barcode">
        <img [alt]="content.barcode.alt" [src]="content.barcode.src" />
      </div>
      <div class="skymiles-landing-page-membership-card__rule">
        {{ content.info }}
        <br />
        <br />
        {{ content.rules }}
      </div>
    </div>
  }
</ng-container>
